import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  InputLabel,
  Button,
  Paper,
  Tabs,
  Tab,
  Select,
  MenuItem,
  FormControl,
  Container,
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { handleAxiosError } from "../../config/action-config";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";

import {
  getEmployeeById,
  deleteEmployee,
  updateEmployee,
  getReportingMangerList,
  getExportToExcel,
  getEmployeePersonalDetailById,
} from "../../api/employee";
import {
  employeeTimesheetTable,
  employeeProjectsTable,
  employeesticketsTable,
} from "../../config/grid-columns-defs";
import {
  getEmployeeTimesheet,
  patchApproveRejectTimesheet,
} from "../../api/timesheet";
import { getLowestLevelTask, getProjects } from "../../api/project";
import {
  assignEmployeeToProject,
  deleteEmployeeProject,
} from "../../api/employeeProject";
import { showAlert } from "../../actions/alert";
import { getTickets, getTicketsByUserId } from "../../api/ticket";
import ConditionalRenderer from "../../component/ConditionalRenderer";
import download from "downloadjs";
import EmployeeDocuments from "./employee.documents";

const deleteApis = {
  PROJECT: deleteEmployeeProject,
  // 'TASK': deleteTask,
  EMPLOYEE: deleteEmployee,
};

const emptyEmployeeData = {
  employeeid: "",
  email: "",
  firstname: "",
  lastname: "",
  role: "",
  user_id: "",
  id: "",
  reportingmanager: "",
  address: "",
  department: "",
  bill_rate: "0",
  contact: "",
   cost_rate: "0",
  creation_date: "",
  joining_date: "",
  employment_status: "",
  designation: "",
  job_title: "",
  job_location: "",
  leave_encashed_date: "",
};

const { monday, sunday } = getThisWeek(new Date().toJSON().slice(0, 10));

export default function ViewEmployee() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [refreshCount, setRefreshCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [employeeData, setEmployeeData] = useState(emptyEmployeeData);
  const [projects, setProjects] = useState([]);

  const [timesheetGridApi, setTimesheetGridApi] = useState(null);
  const [timesheetColDef, setTimesheetColDef] = useState(
    employeeTimesheetTable
    // formatTimesheetHeaders(employeeTimesheetTable, monday)
  );

  const [tabIndex, setTabIndex] = useState(0);
  const [editDisabled, setEditDisabled] = useState(true);

  const [timesheetData, setTimesheetData] = useState([]);
  const [timesheetDates, setTimesheetDates] = useState({
    from: monday,
    to: sunday,
  });
  const [timesheetFromFilterDate, setTimesheetFromFilterDate] =
    useState(monday);
  const [timesheetToFilterDate, setTimesheetToFilterDate] = useState(sunday);
  const [reportingManager, setReportingManager] = useState([]);
  const [detailTabIndex, setDetailTabIndex] = useState(0);
  const [selectedProjectRow, setSelectedProjectRow] = useState(0);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [projectName, setProjectName] = useState("");
  const [projectId, setProjectId] = useState("");
  
  const handleTimesheetDateChange = ({ name, value }) => {
    const { monday, sunday } = getThisWeek(value);
    setTimesheetDates({ from: monday, to: sunday });
  };

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });

  const loadMasterData = () => {
    getEmployeeById(params.id, user.token)
      .then((res) => {
        setEmployeeData(res.data.data.employee);
        setProjects(res.data.data.projects);
        setLoading(false);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };

  const loadTimesheetData = () => {
    getEmployeeTimesheet(
      employeeData.id || params.id,
      // timesheetDates,
      {
        project_id: projectId,
        from: new Date(timesheetFromFilterDate).toJSON(),
        to: new Date(timesheetToFilterDate).toJSON(),
      },
      user.token
    )
      .then((res) => {
        setTimesheetData(res.data.data);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };

  const [ticketData, setTicketData] = useState([]);
  const [employeePersonalDetail, setEmployeePersonalDetail] = useState({});
  
  // const reportingManagerList = () => {
  //   const token = user.token;
  //   return getReportingMangerList(token).then((res) => {
  //     setReportingManager(res.data.data.roledata);
  //   });
  // };
  const reportingManagerList = async () => {
    try {
      const { data } = await getReportingMangerList (user.token)
      setReportingManager([...data.data.roledata]);
    } catch (error) {
      // handleAxiosError(error, dispatch);
      console.error(error);
    }
  };
  console.log(reportingManager,"reportingManager")
  useEffect(() => {
    reportingManagerList();
  }, []);

  const loadTicketData = async () => {
    try {
      const { data } = await getTicketsByUserId(
        { email: employeeData.email },
        user.token
      );
      setTicketData(data.tickets);
    } catch (error) {
      alert("Error while loading tickets.");
    }
  };

  useEffect(() => {
    if (employeeData.email) {
      loadTicketData();
    }
  }, [employeeData.email]);

  // useEffect(() => {
  //   // if at initial postion
  //   if (timesheetDates.from === monday && timesheetDates.to === sunday) return;

  //   const oldColDef = timesheetGridApi.getColumnDefs();
  //   const newTimesheetColDef = formatTimesheetHeaders(
  //     oldColDef,
  //     timesheetDates.from
  //   );
  //   setTimesheetColDef(newTimesheetColDef);
  //   loadTimesheetData();
  // }, [timesheetDates]);
  useEffect(() => {
    // if at initial postion
    if (
      timesheetFromFilterDate === monday &&
      timesheetToFilterDate === sunday
    ) {
      loadTimesheetData();
      return;
    }

    // const oldColDef = timesheetGridApi.getColumnDefs();
    // const newTimesheetColDef = formatTimesheetHeaders(
    //   oldColDef,
    //   timesheetFromFilterDate
    // );
    // setTimesheetColDef(newTimesheetColDef);
    loadTimesheetData();
  }, [timesheetFromFilterDate, timesheetToFilterDate, projectName, projectId]);
  const onTimesheetGridReady = (params) => {
    setTimesheetGridApi(params.api);
    loadTimesheetData();
  };

  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
      loadEmployeePersonalDetails();
    }
  }, [params.id]);

  const changeUpdateData = (e) => {
    setEmployeeData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const onEmployeeDataUpdate = () => {
    updateEmployee(
      employeeData.id,
      getUpdatableEmployeeData(employeeData),
      user.token
    )
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        navigate("/employees")
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "EMPLOYEE") {
          navigate("/employees");
        } else if (deletingContent.table === "EMPLOYEE") {
          loadMasterData();
        } else if (deletingContent.table === "TASK") {
          loadTimesheetData();
        }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };

  const [projectDialogOpen, setProjectDialogOpen] = useState(false);
  const [approveRejectDialogOpen, setApproveRejectDialogOpen] = useState(false);
  const handleProjectAdd = (data) => {
    assignEmployeeToProject(
      { ...data, employee_id: employeeData.id },
      user.token
    )
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setProjectDialogOpen(false);
      })
      .catch((err) => handleAxiosError(err, dispatch));
  };
  const handleApproveReject = (data, approval) => {
    data.approvalstatus = approval;
    patchApproveRejectTimesheet(selectedProjectRow, user.token, data)
      .then((res) => {
        loadTimesheetData();
        dispatch(showAlert(res.data.msg));
        setApproveRejectDialogOpen(false);
        setSelectedProjectRow(0);
        setApprovalStatus("");
      })
      .catch((err) => {
        setApproveRejectDialogOpen(false);
        handleAxiosError(err, dispatch);
      });
  };

  const getExcelViewerData = async() => {
    // if (projectName === "") {
    //   return dispatch(showAlert("Select any input"));
    // }
    return getExportToExcel(
      params.id,
      {
        project_id: projectId,
        from: new Date(timesheetFromFilterDate).toJSON(),
        to: new Date(timesheetToFilterDate).toJSON(),
        excel: "y",
      },
      user.token
    )
      .then((res) => {
        if (res) {
          download(
            res.data,
            new Date().toLocaleDateString() + "_timesheet.csv"
          );
        } else {
          alert("Data not found");
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  
  console.log(employeeData,"employeeData")
  const resetFilterFields = () => {
    setProjectId("");
    setProjectName("");
    setTimesheetFromFilterDate(monday);
    setTimesheetToFilterDate(sunday);
  };
  const rowHeight = 38;

  const loadEmployeePersonalDetails = async () => {
    try {
      const { data } = await getEmployeePersonalDetailById(
        params.id,
        user.token
      );
      setEmployeePersonalDetail(data.data.employee);
    } catch (error) {
      alert("Error while loading details.");
    }
  };
  const isDateKey = (key) => {
    return (
      key === "previous_job_from" || key === "previous_job_to" || key === "dob"
    );
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  };
  return loading ? (
    <Loading />
  ) : (
    <Box className="pmt-container-box">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={detailTabIndex}
          onChange={(e, nv) => {
            setDetailTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Employee Details"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Employee's Personal Details"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Employee's Joining Documents"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Employee's Other Documents"
            id="simple-tab-3"
            aria-controls="simple-tabpanel-3"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={detailTabIndex} index={0}>
        <Paper sx={{ p: "1rem" }}>
          <Box
            sx={{
              display: "flex",
              pb: 1,
              mb: 1,
              borderBottom: 1,
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6">Employee Details</Typography>
            <Box sx={{ display: "flex", columnGap: 1 }}>
              <Button
                variant="contained"
                onClick={() => {
                  setEditDisabled((prev) => !prev);
                }}
                style={{ padding: "5px 7px" }}
              >
                {editDisabled ? "Edit" : "Cancel"}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  setDeletingContent({
                    table: "EMPLOYEE",
                    row: employeeData.id,
                  });
                }}
              >
                Delete
              </Button>
            </Box>
          </Box>

          <Grid container columnSpacing={2} rowSpacing={1} sx={{ pt: "1rem" }}>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="employeeid"
                fullWidth
                value={employeeData.employeeid}
                onChange={changeUpdateData}
                label="Employee Id"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Firstname:</span>{" "}
              {employeeData.firstname}{" "}
            </Typography> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="email"
                fullWidth
                value={employeeData.email}
                onChange={changeUpdateData}
                label="Email"
                type="text"
                variant="outlined"
                disabled
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Email:</span> {employeeData.email}{" "}
            </Typography> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="firstname"
                fullWidth
                value={employeeData.firstname}
                onChange={changeUpdateData}
                label="First name"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Firstname:</span>{" "}
              {employeeData.firstname}{" "}
            </Typography> */}
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="lastname"
                fullWidth
                value={employeeData.lastname}
                onChange={changeUpdateData}
                label="Last name"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Lastname:</span> {employeeData.lastname}{" "}
            </Typography> */}
            </Grid>
            
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl size="small" margin="dense" fullWidth>
                <InputLabel id="demo-simple-select-label">Role</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  name="role"
                  id="demo-simple-select"
                  value={
                    employeeData.role.charAt(0).toUpperCase() +
                    employeeData.role.slice(1)
                  }
                  onChange={changeUpdateData}
                  label="Role"
                  disabled={
                    editDisabled === false && user.role === "Admin"
                      ? false
                      : true
                  }
                >
                  <MenuItem value={"Admin"}>Admin</MenuItem>
                  <MenuItem value={"ReportingManager"}>
                    Reporting Manager
                  </MenuItem>
                  {/* <MenuItem value={"SalesPerson"}>SalesPerson</MenuItem> */}
                  <MenuItem value={"Support"}>Support</MenuItem>
                  <MenuItem value={"User"}>User</MenuItem>
                  
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="contact"
                fullWidth
                value={employeeData.contact}
                error={!/^[0-9]{10}$/.test(employeeData.contact)}
                inputProps={{ maxLength: 10 }}
                onChange={changeUpdateData}
                label="Contact"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Contact:</span> {employeeData.contact}{" "}
            </Typography> */}
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="bill_rate"
              fullWidth
              value={employeeData.bill_rate}
              onChange={changeUpdateData}
              label="Bill Rate"
              type="text"
              variant="outlined"
              disabled={editDisabled}
            />
          </Grid> */}
            {/* <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                //size="small"
                margin="dense"
                name="cost_rate"
                fullWidth
                value={employeeData.cost_rate}
                onChange={changeUpdateData}
                label="Cost Rate ($)"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid> */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="creation_date"
                fullWidth
                value={employeeData.creation_date}
                onChange={changeUpdateData}
                label="Creation Date"
                type="text"
                variant="outlined"
                disabled={true}
              />
              {/* <Typography>
              {" "}
              <span className="fw-500">Creation Date:</span>{" "}
              {formatDate(employeeData.creation_date)}{" "}
            </Typography> */}
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="user_id"
              fullWidth
              value={employeeData.user_id}
              onChange={changeUpdateData}
              label="User Id"
              type="text"
              variant="outlined"
              disabled={true}
            />
            
          </Grid> */}
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                <DatePicker
                  name="joining_date"
                  fullWidth
                  label="Joining Date"
                  value={employeeData.joining_date}
                  onChange={(newValue) =>
                    changeUpdateData({
                      target: { name: "joining_date", value: newValue },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{ marginTop: "10px" }}
                      fullWidth
                      {...params}
                      variant="outlined"
                    />
                  )}
                  disabled={editDisabled}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth style={{ marginTop: "10px" }}>
                <InputLabel id="demo-simple-select-label">
                  Department
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  name="department"
                  id="demo-simple-select"
                  value={employeeData.department || ""}
                  onChange={changeUpdateData}
                  label="Department"
                  disabled={editDisabled}
                >
                  <MenuItem value={"Development"}>Development</MenuItem>,
                  <MenuItem value={"Finance"}>Finance</MenuItem>,
                  <MenuItem value={"Hr"}>HR</MenuItem>,
                  <MenuItem value={"Infrastructure"}>Infrastructure</MenuItem>,
                  <MenuItem value={"Marketing"}>Marketing</MenuItem>,
                  <MenuItem value={"Sales"}>Sales</MenuItem>,
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth style={{ marginTop: "10px" }}>
                <InputLabel id="demo-simple-select-label">
                  Reporting Manager
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  name="reportingmanager"
                  id="demo-simple-select"
                  value={employeeData.reportingmanager}
                  onChange={changeUpdateData}
                  label="Reporting Manager"
                  disabled={editDisabled}
                >
                  <MenuItem value="">Select</MenuItem>
                  {reportingManager.map((r, i) => (
                    <MenuItem key={i} value={r.email}>
                      {r.email}
                    </MenuItem>
                  ))}
                  <MenuItem value="None">None</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="address"
                fullWidth
                value={employeeData.address}
                onChange={changeUpdateData}
                label="Address"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <FormControl fullWidth style={{ marginTop: "10px" }}>
                <InputLabel id="demo-simple-select-label">
                  Employment Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  name="employment_status"
                  id="demo-simple-select"
                  value={employeeData.employment_status}
                  onChange={changeUpdateData}
                  label="Employment Statusr"
                  disabled={editDisabled}
                >
                  <MenuItem value="">Select</MenuItem>

                  <MenuItem value="Current-Employee">Current-Employee</MenuItem>

                  <MenuItem value="Ex-Employee">Ex-Employee</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="designation"
                fullWidth
                value={employeeData.designation}
                onChange={changeUpdateData}
                label="Designation"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="job_title"
                fullWidth
                value={employeeData.job_title}
                onChange={changeUpdateData}
                label="Job Title"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <TextField
                margin="dense"
                name="job_location"
                fullWidth
                value={employeeData.job_location}
                onChange={changeUpdateData}
                label="Job Location"
                type="text"
                variant="outlined"
                disabled={editDisabled}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4}>
              <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                <DatePicker
                  name="leave_encashed_date"
                  fullWidth
                  label="Leave Encashed Date"
                  value={employeeData.leave_encashed_date}
                  onChange={(newValue) =>
                    changeUpdateData({
                      target: { name: "leave_encashed_date", value: newValue },
                    })
                  }
                  renderInput={(params) => (
                    <TextField
                      style={{ marginTop: "10px" }}
                      fullWidth
                      {...params}
                      variant="outlined"
                    />
                  )}
                  disabled={editDisabled}
                />
              </LocalizationProvider>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              display="flex"
              alignItems="center"
            >
              {editDisabled ? (
                <></>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    columnGap: 1,
                    ml: "auto",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={onEmployeeDataUpdate}
                    style={{ padding: "5px 7px" }}
                  >
                    Update
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
        </Paper>
      </TabPanel>
      <TabPanel value={detailTabIndex} index={1}>
        <Paper sx={{ p: "1rem" }}>
          <Grid container spacing={2}>
            {Object.entries(employeePersonalDetail).map(([key, value]) => (
              <Grid item xs={12} md={4} key={key}>
                <Box sx={{ padding: 1 }}>
                  <Typography variant="subtitle1" color="textSecondary">
                    {convertSnakeToPascalCase(key)}
                  </Typography>
                  <Typography variant="body1">
                    {isDateKey(key) ? formatDate(value) : value || "N/A"}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </TabPanel>
      <TabPanel value={detailTabIndex} index={2}>
        <EmployeeDocuments
          id={params.id}
          refreshCount={refreshCount}
          setRefreshCount={setRefreshCount}
          documentTypes={"Joining_Document"}
        />
      </TabPanel>
      <TabPanel value={detailTabIndex} index={3}>
        <EmployeeDocuments
          id={params.id}
          setRefreshCount={setRefreshCount}
          refreshCount={refreshCount}
          documentTypes={"Others_Document"}
        />
      </TabPanel>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Projects"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Timesheet"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Tickets"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          {/* <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
            <Button
              variant="contained"
              style={{ padding: "5px 7px" }}
              onClick={() => {
                setProjectDialogOpen(true);
              }}
            >
              Assign Project
            </Button>
            {Boolean(selectedProjectRow) ? (
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                onClick={() => {
                  setDeletingContent({
                    table: "PROJECT",
                    row: selectedProjectRow,
                  });
                }}
              >
                Delete Selected
              </Button>
            ) : (
              <></>
            )}
          </Box> */}
          <div
            aria-live="polite"
            aria-busy={false}
            className="ag-theme-material pmt-controll-table"
            // style={{ height: "300px" }}
          >
            <AgGridReact
              columnDefs={employeeProjectsTable}
              rowData={projects}
              // rowSelection="single"
              // onRowClicked={(params) => {
              //   setSelectedProjectRow(params.data.ep_id);
              // }}
              domLayout="autoHeight"
              headerHeight="38"
              rowHeight={rowHeight}
              defaultColDef={{
                resizable: true,
                flex: 1,
              }}
            />
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              boxShadow: "0 4px 6px -1px #d0d0d0",
              borderRadius: "6px",
              padding: { sm: "15px 20px", xs: "8px 8px" },
              // background: "#178af4",
              // color: "#101728",
              width: "100%",
            }}
          >
            <Grid
              container
              className="report-filter-box"
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 1, md: 1 }}
            >
              <Grid item lg={2} md={2} sm={4} xs={6}>
                <ConditionalRenderer
                  conditions={[approvalStatus === "Submitted"]}
                  match="SOME"
                >
                  <Grid item xs={12} md={6} lg={4}>
                    <Button
                      variant="contained"
                      className="blue-button"
                      onClick={() => {
                        setApproveRejectDialogOpen(true);
                        // toggleDialogOpen("UPDATE_ACTIVITY");
                      }}
                    >
                      Approve/Reject
                    </Button>
                  </Grid>
                </ConditionalRenderer>
              </Grid>
              <Grid item lg={2} md={2} sm={4} xs={6}>
                <TextField
                  size="small"
                  label="Projects"
                  value={projectName}
                  variant="outlined"
                  select
                  fullWidth
                  onChange={(e) => {
                    const selectedProjectName = e.target.value;
                    setProjectName(selectedProjectName);
                    const selectedIndex = projects.findIndex(
                      (p) => p.project_name === selectedProjectName
                    );
                    const selectedProject = projects[selectedIndex];
                    setProjectId(selectedProject.project_id);
                  }}
                >
                  <MenuItem value="">Select</MenuItem>
                  {projects?.map((c, i) => (
                    <MenuItem key={i} value={c.project_name}>
                      {c.project_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="Start Date"
                    value={timesheetFromFilterDate}
                    onChange={(newValue) => {
                      setTimesheetFromFilterDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    size="small"
                    inputFormat="MM/dd/yyyy"
                    label="End Date"
                    disableFuture
                    shouldDisableDate={disablePrevDates(
                      dayjs(new Date(timesheetFromFilterDate))
                        .subtract(1, "days")
                        .toJSON()
                    )}
                    value={timesheetToFilterDate}
                    onChange={(newValue) => {
                      setTimesheetToFilterDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item lg={2} md={2} sm={4} xs={6}>
                <Button
                  className="export-button"
                  style={{ padding: "5px" }}
                  onClick={() => {
                    getExcelViewerData();
                  }}
                >
                  Export to Excel
                </Button>
              </Grid>
              {/* <Grid item lg={2} md={2} sm={4} xs={6}>
           
          </Grid> */}
              <Grid item lg={2} md={2} sm={4} xs={6}>
                <Button
                  className="export-button"
                  style={{ padding: "5px" }}
                  onClick={() => {
                    resetFilterFields();
                  }}
                >
                  Reset
                </Button>
              </Grid>
            </Grid>
          </Box>

          <hr className="bg-dark" />
          <div
            className="ag-theme-material pmt-controll-table"
            // style={{ height: "300px" }}
          >
            <AgGridReact
              onGridReady={onTimesheetGridReady}
              columnDefs={employeeTimesheetTable}
              // columnDefs={timesheetColDef}
              rowData={timesheetData}
              onRowClicked={(params) => {
                setSelectedProjectRow(params.data.id);
                setApprovalStatus(params.data.approvalstatus);
              }}
              //rowSelection="single"
              domLayout="autoHeight"
              headerHeight="38"
              rowHeight={rowHeight}
            />
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper>
          <div
            className="ag-theme-material pmt-controll-table "
            // style={{ height: "300px" }}
          >
            <AgGridReact
              columnDefs={employeesticketsTable}
              rowData={ticketData}
              domLayout="autoHeight"
              headerHeight="38"
              rowHeight={rowHeight}
              defaultColDef={{
                resizable: true,
                flex: 1,
              }}
              // rowSelection="single"
              // onRowClicked={(params) => {
              //   // setSelectedProjectRow(params.data.ep_id);
              // }}
            />
          </div>
        </Paper>
      </TabPanel>

      <AddProjectDialog
        open={projectDialogOpen}
        setOpen={setProjectDialogOpen}
        onAdd={handleProjectAdd}
        projects={projects}
        token={user.token}
      />

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />

      <ApproveRejectTimesheetDialog
        open={approveRejectDialogOpen}
        setOpen={setApproveRejectDialogOpen}
        onAdd={handleApproveReject}
      />
    </Box>
  );
}

function AddProjectDialog({ open, setOpen, onAdd, projects, token }) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [data, setData] = useState({
    project_id: "",
    project_role: "",
    task_id: "",
  });
  const [freeProjects, setFreeProjects] = useState([]);
  // const [roleList, setRoleList] = useState([]);
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    if (data.project_id) {
      getLowestLevelTask(data.project_id, token)
        .then((res) => {
          setTasks(res.data.data);
        })
        .catch((err) => handleAxiosError(err, dispatch));
    }
  }, [data.project_id]);

  useEffect(() => {
    if (!open) return;
    // const roles = JSON.parse(localStorage.getItem("roles"));
    // if (roles?.length) setRoleList(roles);
    // else cacheEmployeeRoles(user.token, setRoleList);
    getProjects({}, user.token)
      .then((res) => {
        const all = res.data.data;
        const assignedIds = projects.map((e) => e.id);
        setFreeProjects(all.filter((e) => !assignedIds.includes(e.id)));
      })
      .catch((err) => handleAxiosError(err, dispatch));
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Assign Project to Employee
      </DialogTitle>
      <DialogContent>
        <Grid container minWidth={500} spacing={2} sx={{ pt: 2 }}>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">
                Project Name
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={data.project_id}
                label="Project Name"
                name="project_id"
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              >
                {freeProjects.map((p, i) => (
                  <MenuItem key={i} value={p.id}>
                    {p.project_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label-role">Role</InputLabel>
              <Select
                labelId="demo-simple-select-label-role"
                id="demo-simple-select-role"
                value={data.project_role}
                label="Role"
                name="project_role"
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.value,
                  }))
                }
              >
                
                <MenuItem value="PM">Project Manager</MenuItem>
                <MenuItem value="TM">Team Member</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {tasks.length ? (
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label-task">Task</InputLabel>
                <Select
                  labelId="demo-simple-select-label-task"
                  id="demo-simple-select-task"
                  value={data.task_id}
                  label="Task"
                  name="task_id"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                >
                  {tasks.map((t, i) => (
                    <MenuItem key={i} value={t.id}>
                      {t.task_code}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          ) : (
            <>
              {data.project_id ? (
                <Grid item xs={12} md={12}>
                  <Typography
                    color="red"
                    sx={{ border: "1px solid red", borderRadius: "5px", p: 1 }}
                  >
                    Please create tasks for selected project first.
                  </Typography>
                </Grid>
              ) : (
                <></>
              )}
            </>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onAdd(data);
          }}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
        >
          Cancel
        </Button>
        <Button onClick={onDelete} autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
function ApproveRejectTimesheetDialog({ open, setOpen, onAdd }) {
  const [data, setData] = useState({
    approvalstatuscomment: "",
    approvalstatus: "",
  });
  useEffect(() => {
    if (!open) {
      setData({
        approvalstatuscomment: "",
        approvalstatus: "",
      });
    }
    return;
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Approve/Reject Timesheet
      </DialogTitle>
      <DialogContent>
        <Grid container minWidth={500}>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              margin="dense"
              name="approvalstatuscomment"
              multiline={true}
              rows={3}
              fullWidth
              value={data.approvalstatuscomment}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  [e.target.name]: e.target.value,
                }))
              }
              label="Note"
              type="text"
              variant="outlined"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onAdd(data, "Approved");
          }}
        >
          Approve
        </Button>
        <Button
          onClick={() => {
            onAdd(data, "Rejected");
          }}
        >
          Reject
        </Button>
      </DialogActions>
    </Dialog>
  );
}
function formatDate(date) {
  if (!date) return "Not Provided";
  let d = new Date(date);
  return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getThisWeek(date) {
  const utcOffset = dayjs(date).utcOffset();
  const localDate = dayjs(date).add(utcOffset, "minute");
  const dayOfWeek = dayjs(localDate).add(utcOffset, "minute").get("day");

  let thisMonday = dayjs(localDate).subtract(dayOfWeek - 1, "days");
  if (thisMonday.isAfter(localDate)) {
    thisMonday = dayjs(thisMonday).subtract(7, "day");
  }
  const thisSunday = dayjs(thisMonday).add(6, "days");
  return {
    monday: thisMonday.toJSON(),
    sunday: thisSunday.toJSON(),
  };
}

function getUpdatableEmployeeData(data) {
  return {
    employeeid: data.employeeid,
    firstname: data.firstname,
    lastname: data.lastname,
    role: data.role,
    email: data.email,
    contact: data.contact,
    department: data.department,
    bill_rate: data.bill_rate || 0,
    cost_rate: data.cost_rate|| 0,
    address: data.address,
    reportingmanager: data.reportingmanager,
    joining_date: data.joining_date,
    employment_status:
      data.employment_status === null ? "" : data.employment_status,
    designation: data.designation === null ? "" : data.designation||0,
    job_title: data.job_title === null ? "" : data.job_title,
    job_location: data.job_location === null ? "" : data.job_location,
    leave_encashed_date:
      data.leave_encashed_date === null ? "" : data.leave_encashed_date,
  };
}

// function cacheEmployeeRoles(token, setState) {
//   getEmployeeRoles(token)
//     .then((res) => {
//       setState(res.data.data);
//       localStorage.setItem("roles", JSON.stringify(res.data.data));
//     })
//     .catch(() => {
//       localStorage.removeItem("roles");
//     });
// }

let dayMap = {
  monday_hours: 0,
  tuesday_hours: 1,
  wednesday_hours: 2,
  thursday_hours: 3,
  friday_hours: 4,
  saturday_hours: 5,
  sunday_hours: 6,
};
function formatTimesheetHeaders(data = [], start) {
  let formatted = data.map((d, i) => {
    if (/_hours$/.test(d.field)) {
      d.headerName = dayjs(start)
        .add(dayMap[d.field], "day")
        .toISOString()
        .slice(0, 10);
      return d;
    }
    return d;
  });

  return formatted;
}
function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
const convertSnakeToPascalCase = (str) => {
  const customTitles = {
    dob: "Date Of Birth",
    uan_number: "UAN Number",
    // Add more custom titles as needed
  };

  if (customTitles[str]) {
    return customTitles[str];
  }

  return str
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
